import { useGLTF } from '@react-three/drei';
import * as global from "../../data/global";

export function An4(props) {
    const { nodes } = useGLTF('3ds/an/An4.gltf')
    return (
        <group {...props} dispose={null}>
            <mesh
                ref={e => {
                    if (!e) return;
                    if (!global.gw.geometries.An4) {
                        global.gw.geometries.An4 = e.geometry;
                    }
                }}
                name="An4"
                geometry={nodes.An4.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/An4.gltf');